export const RUN_STATUSES = ["running", "ok", "error", "unknown"];
export const RUN_SOURCES = [
    "cron",
    "github-actions",
    "manual",
    "astack",
    "other",
];
export const SPAN_STATUSES = ["ok", "error", "unset"];
export const EVENT_SEVERITIES = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal",
];
export const WS_MESSAGE_TYPES = {
    RUN_CHANGE: "run-change",
    SNAPSHOT: "snapshot",
    PING: "ping",
    PONG: "pong",
};
export const STUCK_RUN_THRESHOLD_MS = 30 * 60 * 1000; // 30 minutes
/**
 * Row cap on the "running runs" set, shared by both sides of FR-3.1 for two
 * distinct reasons:
 *
 * - Within the web app, the TanStack cache key carries `limit`. `useLiveSync`
 *   writes the snapshot frame under `runs({status:"running", limit})` and the
 *   Live view subscribes with the same `limit`; if those two drift, the write
 *   lands on a key nothing observes and the frame is discarded. This is a
 *   client-only agreement — the API's cap plays no part in it.
 * - Between API and web app, `RunService.listRunning()` (which builds the
 *   snapshot) applies the same cap as the view's `/api/runs?status=running`
 *   query, so the snapshot paint and the refetch that follows it agree on how
 *   many rows fit and the list doesn't grow or shrink on reconnect.
 */
export const RUNNING_RUNS_LIMIT = 200;
/**
 * Model used for run summaries when no `summary_model` setting is stored. The
 * API's `getAnthropicConfig` falls back to it, and the SPA's Settings form
 * pre-fills and describes it — one copy, so the default the operator is shown
 * is the one the summary call actually uses.
 */
export const DEFAULT_SUMMARY_MODEL = "claude-haiku-4-5";
//# sourceMappingURL=index.js.map